(function () {
  const quantityRoots = document.querySelectorAll('.main-product__content');
  const stickyCart = document.querySelector('.sticky-add-to-cart');

  function setQuantityValue(root, value) {
    const qty = Math.max(1, parseInt(value, 10) || 1);
    const visibleInput = root.querySelector('.quantity input');
    const hiddenInput = root.querySelector('#quantity');
    if (visibleInput) visibleInput.value = qty;
    if (hiddenInput) hiddenInput.value = qty;

    if (stickyCart) {
      const stickyVisible = stickyCart.querySelector('.quantity input');
      const stickyHidden = stickyCart.querySelector('#quantity');
      if (stickyVisible) stickyVisible.value = qty;
      if (stickyHidden) stickyHidden.value = qty;
    }

    return qty;
  }

  quantityRoots.forEach(function (root) {
    const plus = root.querySelector('button[name="plus"]');
    const minus = root.querySelector('button[name="minus"]');
    const input = root.querySelector('input[name="quantity"]');
    const hidden = root.querySelector('#quantity');
    if (!input || !hidden) return;

    const stickyPlus = stickyCart && stickyCart.querySelector('button[name="plus"]');
    const stickyMinus = stickyCart && stickyCart.querySelector('button[name="minus"]');
    const stickyInput = stickyCart && stickyCart.querySelector('input[name="quantity"]');

    function currentValue() {
      return parseInt(hidden.value || input.value, 10) || 1;
    }

    function increment() {
      if (input.disabled) return;
      setQuantityValue(root, currentValue() + 1);
    }

    function decrement() {
      if (input.disabled) return;
      const next = currentValue();
      if (next > 1) setQuantityValue(root, next - 1);
    }

    function onManualChange(event) {
      if (input.disabled) return;
      const next = parseInt(event.target.value, 10);
      if (next > 0) setQuantityValue(root, next);
    }

    function blockNonDigits(event) {
      if (event.which !== 8 && event.which !== 0 && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
      }
    }

    if (plus) plus.addEventListener('click', increment);
    if (minus) minus.addEventListener('click', decrement);
    input.addEventListener('change', onManualChange);
    input.addEventListener('keypress', blockNonDigits);

    if (stickyPlus && stickyMinus && stickyInput) {
      stickyPlus.addEventListener('click', increment);
      stickyMinus.addEventListener('click', decrement);
      stickyInput.addEventListener('change', onManualChange);
      stickyInput.addEventListener('keypress', blockNonDigits);
    }
  });

  function fieldValue(field) {
    if (!field) return null;
    if (field.tagName === 'SELECT') return field.value;
    const checked = field.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function quantityOptionValue(event) {
    if (event) {
      const target = event.target || (event.detail && event.detail.event && event.detail.event.target);
      if (target && target.closest) {
        const fromEvent = target.closest('[data-quantity-option]');
        const fromEventValue = fieldValue(fromEvent);
        if (fromEventValue != null) return fromEventValue;
      }
    }

    const main = document.querySelector('.main-product fieldset[data-quantity-option], .main-product select[data-quantity-option]');
    const mainValue = fieldValue(main);
    if (mainValue != null) return mainValue;

    const any = document.querySelector('[data-quantity-option]');
    return fieldValue(any);
  }

  function isCustomQuantity(value) {
    return String(value || '').trim().toLowerCase() === 'quantity';
  }

  function setPickerEnabled(enabled) {
    document.querySelectorAll('.quantity').forEach(function (picker) {
      const input = picker.querySelector('input[name="quantity"]');
      const buttons = picker.querySelectorAll('button');
      picker.classList.toggle('is-disabled', !enabled);
      picker.setAttribute('aria-disabled', enabled ? 'false' : 'true');

      if (input) {
        input.disabled = !enabled;
        if (!enabled) input.value = '1';
      }

      buttons.forEach(function (button) {
        button.disabled = !enabled;
      });
    });

    document.querySelectorAll('.main-product__quantity').forEach(function (wrap) {
      wrap.classList.toggle('is-qty-locked', !enabled);
      wrap.classList.toggle('is-qty-custom', enabled);
    });

    if (!enabled) {
      document.querySelectorAll('#quantity').forEach(function (field) {
        field.value = '1';
      });
    }
  }

  function syncQuantityPicker(event) {
    const value = quantityOptionValue(event);
    if (value == null) return;
    setPickerEnabled(isCustomQuantity(value));
  }

  function bindQuantityOptionToggle() {
    document.querySelectorAll('variant-selects').forEach(function (selects) {
      if (selects.dataset.qtyToggleBound === 'true') return;
      selects.dataset.qtyToggleBound = 'true';
      selects.addEventListener('change', syncQuantityPicker);
    });
    syncQuantityPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQuantityOptionToggle);
  } else {
    bindQuantityOptionToggle();
  }

  document.addEventListener('shopify:section:load', bindQuantityOptionToggle);
  document.addEventListener('variant-update', syncQuantityPicker);
})();
